var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-image',{style:({width: _vm.width, height: _vm.height}),attrs:{"src":_vm.src,"preview-src-list":_vm.srcList}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }